export default __webpack_public_path__ + "static/media/University of Ottawa.cfd0e717.png";